import { ref } from 'vue'

import { listVideoPreparation } from '../../api'

export const scenarioId = ref('')
export const preparationItems = ref([])

let loading = null

export async function loadScenarioOptions(locale) {
  if (loading !== null) return loading
  loading = listVideoPreparation(locale).then(data => {
    preparationItems.value = data.items
    if (scenarioId.value === '' && data.items.length > 0) scenarioId.value = data.items[0].scenario_id
    if (scenarioId.value !== '' && !data.items.some(item => item.scenario_id === scenarioId.value)) {
      throw new Error(`Unknown intent video scenario: ${scenarioId.value}`)
    }
    return data.items
  })
  return loading
}

export function selectScenario(id) {
  scenarioId.value = id
}
